import React from "react";
import { AiOutlineBarChart } from "react-icons/ai";
import { BsFillJournalBookmarkFill } from "react-icons/bs";
import Link from "next/link";
import {MdOutlinePublic} from "react-icons/md";

export default function DiaryPublicNav() {
    return (
        <div className="flex flex-row gap-4">
            <Link href="/diary">
                <BsFillJournalBookmarkFill className="inline-block"/> Diary
            </Link>
            <Link href="/diary/log"><AiOutlineBarChart className="inline-block"/> Private Log</Link>
        </div>
    );
}